module.exports = __webpack_public_path__ + "assets/img/ctm-fill-bill-avia.f9d3c66b.png";